import React, { useState, useCallback } from 'react';
import './t&c.scss';
import termsData from '../../assets/json/termsAndConditions.json';
import MenuItem from '../header/MenuItem.js'

const TermsAndConditions = () => {
    const [menuState, setMenuState] = useState(0);
    const onMove = useCallback((to) => {
        setMenuState(to);
    }, [setMenuState]);

    return(
        <div className="terms-container">
            <div className="t-right-col">
                <div className="nav-container">
                    {termsData.terms.map((item,index)=>(
                        <MenuItem key={index} active={menuState === index} to="/terms" moveTo={index} onMove={onMove}>
                            {item.section}
                        </MenuItem>)
                    )}
                </div>
            </div>
            <div className="t-left-col">
                <div className="terms-title">
                    <h1 className="title-text">Terms & Conditions</h1>
                    <p>Last updated: 1st of June 2020</p>
                    <p>The following Terms and Conditions apply to any use of the Service.</p>
                </div>
                <div className="terms-content">
                    {termsData.terms.map((item, index)=>(
                        <div id={index} key={index}>
                            <h2 className="section-title">{item.section}</h2>
                            {!!item.text && item.text.map((text, index) => (
                                <p key={index} className="section-text">{text}</p>
                            ))}
                            <ul>
                                {!!item.subSections && item.subSections.map((listItem) => (
                                    <li key={listItem.title}>
                                        <span className="subsection-title">{listItem.title}</span> {listItem.text}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default TermsAndConditions;
